import { render, staticRenderFns } from "./uni-number-box.vue?vue&type=template&id=0bbad3e2&"
import script from "./uni-number-box.vue?vue&type=script&lang=js&"
export * from "./uni-number-box.vue?vue&type=script&lang=js&"
import style0 from "./uni-number-box.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbad3e2')) {
      api.createRecord('0bbad3e2', component.options)
    } else {
      api.reload('0bbad3e2', component.options)
    }
    module.hot.accept("./uni-number-box.vue?vue&type=template&id=0bbad3e2&", function () {
      api.rerender('0bbad3e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uni-number-box/uni-number-box.vue"
export default component.exports